import * as React from 'react'
import {Box} from '@mui/material'
import {MUTED, withOpacity} from '../../../../styles/foundation/colors'

/**
 * A flat sleeve, for a parcel that has no usable box yet.
 *
 * `CartonSVG` needs three positive sides and correctly refuses to draw without
 * them, which leaves any screen that draws from TYPED dimensions with an empty
 * slot until the merchant has entered all three — the slot then appears from
 * nowhere and shifts everything beside it. This fills it with a shape that says
 * "soft pack" rather than inventing a box: no isometric depth, one fold line,
 * muted.
 *
 * It is an ILLUSTRATION, not a measurement. It never scales to anything, which
 * is why a caller pairs it with the same "Not to scale" caption it gives
 * `CartonSVG` — the caption must not change when the shape does.
 */
export default function SleeveSVG({size = 96}) {
  const w = size
  const h = size * 0.72
  return (
    <Box
      component='svg'
      role='img'
      aria-label='Soft pack, no box entered'
      viewBox={`0 0 ${w} ${h}`}
      sx={{width: w, height: h, display: 'block'}}
    >
      <rect
        x={w * 0.12} y={h * 0.14} width={w * 0.76} height={h * 0.72}
        rx='6' fill={withOpacity(MUTED, 0.14)} stroke={MUTED} strokeWidth='1.5'
      />
      <path
        d={`M ${w * 0.12} ${h * 0.36} L ${w * 0.88} ${h * 0.36}`}
        stroke={MUTED} strokeWidth='1.5' strokeDasharray='3 3' fill='none'
      />
    </Box>
  )
}
